/**
 * @param raw
 * @return {videoModel.type}
 */
export const videoModel = (raw) => ({
  id: raw.id || '',
  title: raw.title || '',
  description: raw.description || '',
  thumbnail: raw.thumbnail || {
    id: null,
    url: null,
  },
  length: Number.isInteger(raw.length) ? raw.length : -1,
  displayDate: raw.displayDate,
  plays: Number.isInteger(raw.plays) ? raw.plays : -1,
  keywords: raw.keywords || [],
  channels: raw.channels || [],
  playerToken: raw.playerToken || '',
  ratingAvg: raw.ratingAvg || 0,
  userRating: raw.userRating || 0,
  totalComments: raw.totalComments || 0,
  uploaderUserId: raw.uploaderUserId || -1,
  responsibleUserId: raw.responsibleUserId || -1,
  countries: raw.countries || [],
  languages: raw.languages || [],
  featured: raw.featured || false,
  saved: raw.saved || false,
  uitVideoDownloadableStatus: raw.uitVideoDownloadableStatus || 0,
  playable: raw.playable || false,
});

/**
 * @typedef {{
 *    id: string,
 *    title: string,
 *    description: string,
 *    thumbnail: ?videoModel.thumbnailType,
 *    length: number,
 *    displayDate: number,
 *    plays: number,
 *    keywords: string[],
 *    channels: string[],
 *    playerToken: string,
 *    ratingAvg: number,
 *    userRating: number,
 *    totalComments: number,
 *    uploaderUserId: number,
 *    responsibleUserId: number,
 *    countries: string[],
 *    languages: string[],
 *    featured: boolean,
 *    saved: boolean,
 *    uitVideoDownloadableStatus: number
 * }}
 */
videoModel.type = null;

/**
 * @typedef {{
 *   id: ?number,
 *   url: ?string
 * }}
 */
videoModel.thumbnailType = null;
